import { SVGImagesProps } from "./svgTypes";

export const Transfer = ({ color }: SVGImagesProps) => {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5099 11.6813C11.4107 9.11302 9.45099 7.05713 7.05656 7.05713C4.66239 7.05713 2.70264 9.11302 2.60352 11.6811C3.15845 12.0096 5.00147 13 7.05656 13C9.11787 13 10.9563 12.0101 11.5099 11.6813Z"
        fill={color}
      />
      <path
        d="M7.05632 6.31431C8.08034 6.31431 8.91343 5.48122 8.91343 4.4572C8.91343 3.43318 8.08034 2.6001 7.05632 2.6001C6.0323 2.6001 5.19922 3.43318 5.19922 4.4572C5.19922 5.48122 6.0323 6.31431 7.05632 6.31431Z"
        fill={color}
      />
      <path
        d="M18.943 16.7142C19.9671 16.7142 20.8001 15.8811 20.8001 14.8571C20.8001 13.8331 19.9671 13 18.943 13C17.919 13 17.0859 13.8331 17.0859 14.8571C17.0859 15.8811 17.919 16.7142 18.943 16.7142Z"
        fill={color}
      />
      <path
        d="M18.9435 17.457C16.5491 17.457 14.5896 19.5129 14.4902 22.081C15.0454 22.4095 16.8885 23.3999 18.9435 23.3999C21.0046 23.3999 22.8433 22.41 23.3966 22.0812C23.2977 19.5129 21.338 17.457 18.9435 17.457Z"
        fill={color}
      />
      <path
        d="M8.54353 21.1712H11.5148C11.7201 21.1712 11.8864 21.0049 11.8864 20.7999C11.8864 20.5949 11.7201 20.4286 11.5148 20.4286H8.54353C7.10974 20.4286 5.94353 19.2621 5.94353 17.8286V17.2395L6.79503 18.091C6.86761 18.1636 6.96268 18.1999 7.05774 18.1999C7.1528 18.1999 7.24786 18.1636 7.32045 18.091C7.46534 17.9458 7.46534 17.711 7.32045 17.5659L5.83466 16.0801C5.68949 15.9349 5.45468 15.9349 5.30951 16.0801L3.82372 17.5659C3.67855 17.711 3.67855 17.9458 3.82372 18.091C3.96889 18.2362 4.20397 18.2362 4.34886 18.091L5.20064 17.2395V17.8286C5.20064 19.6716 6.70024 21.1712 8.54353 21.1712Z"
        fill={color}
      />
      <path
        d="M17.4562 4.82861H14.4849C14.2796 4.82861 14.1133 4.9949 14.1133 5.19993C14.1133 5.40495 14.2796 5.57124 14.4849 5.57124H17.4562C18.89 5.57124 20.0562 6.73772 20.0562 8.17124V8.7603L19.2044 7.9088C19.0595 7.76363 18.8244 7.76363 18.6793 7.9088C18.5341 8.0537 18.5341 8.28878 18.6793 8.43395L20.1651 9.91974C20.2376 9.99232 20.3327 10.0286 20.4278 10.0286C20.5226 10.0286 20.6176 9.99232 20.6902 9.91974L22.176 8.43395C22.3212 8.28878 22.3212 8.0537 22.176 7.9088C22.0308 7.76363 21.7957 7.76363 21.6508 7.9088L20.7991 8.7603V8.17124C20.7991 6.32822 19.2995 4.82861 17.4562 4.82861Z"
        fill={color}
      />
    </svg>
  );
};
